import { DailyDto, JobDto } from 'src/api/FiretrolApiClient';

export type DailyStep =
  | 'job'
  | 'description'
  | 'photos'
  | 'questions'
  | 'progress'
  | 'timesheets'
  | 'submit';

export const DailyStepMap: Record<DailyStep, DailyStep> = {
  job: 'job',
  description: 'description',
  photos: 'photos',
  questions: 'questions',
  progress: 'progress',
  timesheets: 'timesheets',
  submit: 'submit',
};

export const DailyStepIndexMap: Record<DailyStep, number> = {
  job: 0,
  description: 1,
  photos: 2,
  questions: 3,
  progress: 4,
  timesheets: 5,
  submit: 6,
};

export interface StepProps {
  values: DailyDto;
  setFieldValue: (field: string, value: any) => void;
  // Formik's setFieldValue does not mark the field touched, so steps call this
  // explicitly after toggling exclude flags - the office-settings load race
  // guard relies on this.
  setFieldTouched: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean,
  ) => void;
  selectedJob: JobDto | null;
}
